import { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { setAccessTokenGetter } from "./api/apiClient";

const Auth0TokenMiddleware = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  useEffect(() => {
    setAccessTokenGetter(async () => {
      if (!isAuthenticated) {
        return null;
      }
      return getAccessTokenSilently();
    });
  }, [getAccessTokenSilently, isAuthenticated]);

  return null;
};

export default Auth0TokenMiddleware;
